import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "5 months of blog traffic in 4 days",
  "description": "",
  "published": "2011-12-20T00:00:00.000Z",
  "redirect_from": ["/blog/5-months-of-blog-traffic-in-4-days/swizec/3218"],
  "categories": "Google Analytics, Online Communities, Reddit, Social network, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-20-at-5.03.15-PM-300x171.png",
        "alt": "A traffic spike",
        "title": "A traffic spike"
      }}></img></p>
    <p>{`On Thursday I published my most popular post to date `}<em parentName="p"><a parentName="em" {...{
          "href": "http://swizec.com/blog/why-programmers-work-at-night/swizec/3198",
          "title": "Why programmers work at night"
        }}>{`Why programmers work at night`}</a></em>{`. After writing I was certain it wasn't that interesting, sure it might be HN frontpage worthy - it never got there - but other than that I felt it wasn't a very informative post, just musings of a hacker who has always loved the night-time.`}</p>
    <p>{`The internets had other plans. Some guy posted it on `}<a parentName="p" {...{
        "href": "http://reddit.com/",
        "title": "Reddit"
      }}>{`reddit`}</a>{` about half an hour after I published and for the next 30 or so hours it was at the top of /r/programming. Even showing up on the main frontpage briefly according to people on `}<a parentName="p" {...{
        "href": "http://twitter.com",
        "title": "Twitter"
      }}>{`Twitter`}</a>{`, I wouldn't know, my reddit karma is 4.`}</p>
    <p>{`As is the trend when extraordinary traffic happens on a personal site, I will now `}<del parentName="p">{`brag about`}</del>{` share the stats.`}</p>
    <p>{`Analytics for the last four days:`}</p>
    <ul>
      <li parentName="ul">{`167,939 visits`}</li>
      <li parentName="ul">{`157,707 uniques`}</li>
      <li parentName="ul">{`188,707 pageviews`}</li>
    </ul>
    <p>{`The peak day was Friday and saw just over 89k visitors. Because gAnalytics offers that real-time thingy, I can also say that the peak traffic I saw was about 600 concurrent visitors and for the first five or so hours it was up on reddit, the mean was something like 400 `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Concurrent_user",
        "title": "Concurrent user"
      }}>{`concurrent users`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-20-at-4.50.42-PM.png",
        "alt": "30 day analytics",
        "title": "30 day analytics"
      }}></img></p>
    <p>{`If you're so awesome this doesn't sound like a lot - my usual monthly traffic is around 30k visitors. We are talking about `}<em parentName="p">{`four days`}</em>{` here.`}</p>
    <p>{`There was also a lot of social madness:`}</p>
    <ul>
      <li parentName="ul">{`1,714 points on reddit (2,866 upvotes, 1,152 downvotes)`}</li>
      <li parentName="ul">{`40 upvotes on HN, no frontpage, just people submitting the article over the four days`}</li>
      <li parentName="ul">{`627 G+`}</li>
      <li parentName="ul">{`2,877 tweets`}</li>
      <li parentName="ul">{`550+ tweets mentioning me next to the link (hard to measure since search API only returns up to 1500 results)`}</li>
      <li parentName="ul">{`288 new followers on twitter ... I should probably take the time to follow some back`}</li>
      <li parentName="ul">{`unknown amount of facebook likes, because I never quite got around to setting up the widget or Insights properly`}</li>
      <li parentName="ul">{`475 comments on reddit`}</li>
      <li parentName="ul">{`173 comments on my blog`}</li>
      <li parentName="ul">{`some emails directly to me`}</li>
      <li parentName="ul">{`three or four people looking for a freelancer`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ak-26.ru/?p=1258"
        }}>{`somebody even translated the post to Russian`}</a></li>
    </ul>
    <p>{`How all of this happened? I honestly haven't a clue, there are tens if not hundreds of posts on this blog more deserving of such infamy, but I guess people like a good pat on the back and an easy `}<em parentName="p">{`"Yeah totally. I can totally agree with that!".`}</em></p>
    <p>{`The best bit of feedback came not from programmers, all of them were just "Yeah me too!" or "You're an idiot!", nope, the best were their wives and people who have to live with programmers claiming that now they can finally understand their werewolf programmer and how it thinks. Makes me feel I accomplished something with the post :)`}</p>
    <p>{`Oh and the most surprising thing here? The post was 900 words long! Should be a death sentence on the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Internet",
        "title": "Internet"
      }}>{`intarwebs`}</a>{`, but I guess I made good enough points early on so people still wanted to share. My fancy `}<a parentName="p" {...{
        "href": "http://www.mixpanel.com",
        "title": "Mixpanel"
      }}>{`mixpanel`}</a>{` analytics says about `}<strong parentName="p">{`42%`}</strong>{`of readers made it through all the twenty-two paragraphs.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-20-at-4.55.25-PM.png",
        "alt": "Paragraph funnel",
        "title": "Paragraph funnel"
      }}></img></p>
    <p>{`Broken down for referrers:`}</p>
    <ul>
      <li parentName="ul">{`46% people from G+ finished reading (plus.url.google.com)`}</li>
      <li parentName="ul">{`45% people from twitter (t.co)`}</li>
      <li parentName="ul">{`43% people from mobile facebook (m.facebook.com)`}</li>
      <li parentName="ul">{`41% people from facebook (`}<a parentName="li" {...{
          "href": "http://www.facebook.com"
        }}>{`www.facebook.com`}</a>{`)`}</li>
      <li parentName="ul">{`39% people from reddit (`}<a parentName="li" {...{
          "href": "http://www.reddit.com"
        }}>{`www.reddit.com`}</a>{`)`}</li>
    </ul>
    <p>{`An interesting note here, this list is ordered in exactly the inverse of amount of people referred. `}<a parentName="p" {...{
        "href": "http://reddit.com/",
        "title": "Reddit"
      }}>{`Reddit`}</a>{` drove the most traffic, but it also drove the shittiest traffic, while G+ brought the least, but the most people finished reading.`}</p>
    <p>{`Although I think the days of that analytic might be numbered, mixpanel will get fed up with me and I won't be able to afford the service :(`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Screen-Shot-2011-12-20-at-4.53.01-PM.png",
        "alt": "Mixpanel datapoints",
        "title": "Mixpanel datapoints"
      }}></img></p>
    <p>{`Edit: fixed the facebook widget, it reports 7k likes.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.kissmetrics.com/reddit-marketing-guide/"
        }}>{`Reddit Marketing Guide`}</a>{` (kissmetrics.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.distilled.net/blog/social-media/a-web-marketers-guide-to-reddit/"
        }}>{`A Web Marketer's Guide to Reddit`}</a>{` (distilled.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8566537/linking-a-users-reddit-account-with-my-site-without-storing-their-reddit-passwo"
        }}>{`Linking a user's reddit account with my site with out storing their reddit password`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thenextweb.com/insider/2011/10/31/reddit-did-1-8-billion-page-views-in-the-last-30-days-with-28m-unique-visitors/"
        }}>{`Reddit did 1.8 BILLION page views in the last 30 days, with 28m unique visitors`}</a>{` (thenextweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.socialmaximizer.com/tweet-your-way-to-1000%e2%80%99s-of-followers/"
        }}>{`Top 10 Tips to Tweet your way to 1000's of Followers`}</a>{` (socialmaximizer.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0494ecb9-e011-4bb5-8680-10e213df9b15",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      